module.exports = __webpack_public_path__ + "media/images/mobile-app-d6ea6bdd5a7cb878c22aa8722a0e4332.png";